export default[
    {
        path: '/collectMoney/productFootBath',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '产品泡脚',
            keepAlive: false
        }
    }
]